import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionLabel from "../site/SectionLabel";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LatestBlogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { fetch(`${API}/api/public/blogs?limit=6`).then((r) => r.json()).then((d) => setItems(Array.isArray(d) ? d : [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="relative bg-ink-950 py-24 lg:py-32" data-testid="home-latest-blogs">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="flex items-end justify-between gap-6">
          <div>
            <SectionLabel number="12">Latest Insights</SectionLabel>
            <h2 className="mt-6 font-display text-4xl leading-[1.02] tracking-tight text-ivory lg:text-6xl">
              Ideas on design, <span className="italic text-gold">business and growth.</span>
            </h2>
          </div>
          <Link to="/blog" className="group hidden shrink-0 items-center gap-3 font-sans text-[11px] uppercase tracking-widest text-gold transition-colors hover:text-ivory sm:inline-flex" data-testid="home-view-all-blogs">
            View All Blogs <span className="h-px w-8 bg-current transition-all group-hover:w-12" />
          </Link>
        </div>
        <div className="mt-14 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
          {items.slice(0, 6).map((b, i) => (
            <motion.article key={b.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: (i % 3) * 0.05 }}>
              <Link to={`/blog/${b.slug}`} className="group block" data-testid={`home-blog-${b.slug}`}>
                <div className="relative aspect-[16/9] overflow-hidden border border-ivory/[0.06] bg-ink-800">
                  <img src={b.featured_image} alt={b.image_alt || b.title} loading="lazy" className="h-full w-full object-cover grayscale-[20%] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" />
                </div>
                <div className="mt-4 font-sans text-[11px] uppercase tracking-widest text-gold">{b.category} · {b.reading_time || 4} min</div>
                <h3 className="mt-2 font-display text-xl leading-tight tracking-tight text-ivory transition-colors group-hover:text-gold lg:text-2xl">{b.title}</h3>
                <p className="mt-2 line-clamp-2 font-sans text-sm leading-relaxed text-ivory-muted">{b.excerpt}</p>
                <span className="mt-3 inline-block font-sans text-[11px] uppercase tracking-widest text-gold">Read more →</span>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
